import { RootPaths } from "@src/appV2/App/paths";
import { useAutoApprovedQualifications } from "@src/appV2/Licenses/useAutoApprovedQualifications";
import { type ReactElement, useRef } from "react";
import { generatePath, useHistory } from "react-router-dom";

import { PageWrapper } from "../../components/PageWrapper";
import { StickyScrollPageHeader } from "../../components/StickyScrollPageHeader";
import { RolesPageContent } from "../../Roles/PageContent";
import { RolesPageFooter } from "../../Roles/PageFooter";
import { useWorkerQualificationsWithLicenses } from "../../Roles/useWorkerQualificationsWithLicenses";
import { ACCOUNT_ADD_ROLE_FULL_PATH, ACCOUNT_ROLE_DETAILS_FULL_PATH } from "./paths";

export function AccountRolesPage(): ReactElement {
  const history = useHistory();

  const { data, isLoading, isSuccess } = useWorkerQualificationsWithLicenses();

  const autoApprovedQualifications = useAutoApprovedQualifications();

  const isEmpty = isSuccess && data.length === 0;

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        shouldWrapTitle
        title="Manage Roles & Licenses"
        scrollContainerRef={scrollContainerRef}
        headerVariant="tertiary"
        fallbackGoBackPath={`${RootPaths.HOME}/account`}
      />

      <RolesPageContent
        isEmpty={isEmpty}
        scrollContainerRef={scrollContainerRef}
        autoApprovedQualifications={autoApprovedQualifications}
        qualificationsWithLicenses={data}
        isLoading={isLoading}
        onAddRole={() => {
          history.push(ACCOUNT_ADD_ROLE_FULL_PATH);
        }}
        onRoleClick={(qualificationId) => {
          history.push(generatePath(ACCOUNT_ROLE_DETAILS_FULL_PATH, { qualificationId }));
        }}
      />

      {!isEmpty && (
        <RolesPageFooter
          onAddRole={() => {
            history.push(ACCOUNT_ADD_ROLE_FULL_PATH);
          }}
        />
      )}
    </PageWrapper>
  );
}
